import { useVacationMode } from "./useVacationMode";

export default function VacationModeAlert() {
  const vacationMode = useVacationMode();

  if (!vacationMode) {
    return null;
  }

  return (
    <div
      style={{
        background: "#2196f3",
        color: "#fff",
        textAlign: "center",
        padding: "1rem",
        fontSize: "1.2rem",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        In order to give our team a much needed break, we are pausing sales of
        photo maps until <strong>early September, 2025</strong>. We will still
        fulfill photo sticker orders during this time.
      </div>
    </div>
  );
}
